import { render, staticRenderFns } from "./BaseImg.vue?vue&type=template&id=1004d43e&scoped=true&"
import script from "./BaseImg.vue?vue&type=script&lang=js&"
export * from "./BaseImg.vue?vue&type=script&lang=js&"
import style0 from "./BaseImg.vue?vue&type=style&index=0&id=1004d43e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1004d43e",
  null
  
)

export default component.exports